"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _createIconComponent = _interopRequireDefault(require("./utils/createIconComponent"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var IconPlus = (0, _createIconComponent["default"])({
  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M35 65.21a2.37 2.37 0 0 1-2.37-2.37V7.17a2.37 2.37 0 1 1 4.75 0v55.66A2.37 2.37 0 0 1 35 65.21z"
  }), _react["default"].createElement("path", {
    d: "M62.83 37.37H7.17a2.37 2.37 0 1 1 0-4.75h55.66a2.37 2.37 0 1 1 0 4.75z"
  })),
  height: undefined,
  width: undefined
});
IconPlus.displayName = 'IconPlus';
var _default = IconPlus;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@tecuity/sos-icons/react/plus.js
// module id = 337
// module chunks = 0